import React, {Component} from "react"
import {Link} from "react-router-dom"
import {Button, Icon} from "semantic-ui-react"

import Sidebar from "components/Sidebar/Sidebar"
import CartMini from "components/Cart/CartMini"
import app from "app.controller"
import NavigationSidebar from "components/Navigation/NavigationSidebar"
import OrderlistSelection from "components/Orderlist/OrderlistSelection"
import Header from "components/Header/Header"
import Footer from "components/Footer/Footer"
import shop from "shop/shop"

import "style/util.scss"
import "./PageLayout.scss"

class FooterLayout extends Component {

  render() {
    return (
      <div className="FooterLayout">
        <div className="page-content min-vh-100">
          {this.props.children}
        </div>
        <Footer/>
      </div>
    )
  }
}

export default FooterLayout



// WEBPACK FOOTER //
// ./src/theme/base/layout/FooterLayout.js